import { render, staticRenderFns } from "./SongAnswerCard.vue?vue&type=template&id=93233b70"
import script from "./SongAnswerCard.vue?vue&type=script&lang=js"
export * from "./SongAnswerCard.vue?vue&type=script&lang=js"
import style0 from "./SongAnswerCard.vue?vue&type=style&index=0&id=93233b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports